import ProfilePageContent from "../../components/profile/profileContent";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import RootLayout from "../layout";
import httpService from "../../services/http.service";
import { getBillingApiRoute } from "../../utils/api.utils";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../redux/Slices/loading.slice";
import PageLayout from "../../components/layout/PageLayout";
import { getUser } from "../../services/authService";
import { hasAuthenticatedSession } from "../../services/authStorage";

const checkAuth = () => hasAuthenticatedSession();

const ProfilePage = () => {
  const auth = checkAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  async function getProfileInfo() {
    const userData = await getUser();

    // Fetch current subscription info with remainingAccessDays
    let currentSubscription = null;
    try {
      const subscriptionResponse = await httpService.get(
        getBillingApiRoute("payment/subscription/current")
      );
      if (subscriptionResponse.status === 200 && subscriptionResponse.data?.data) {
        currentSubscription = subscriptionResponse.data.data;
      }
    } catch (error) {
      console.warn("Could not fetch current subscription:", error);
    }

    return {
      ...userData,
      activeSubscription: currentSubscription,
    };
  }

  useEffect(() => {
    if (!auth) {
      navigate("/login", { replace: true });
    }
  }, [auth, navigate]);

  useEffect(() => {
    if (!auth) return undefined;

    // Start loading - disables sidebar navigation
    dispatch(startLoading("در حال بارگذاری پروفایل..."));

    getProfileInfo().then((data) => {
      setData(data);
      setLoading(false);
      // Stop loading - re-enables sidebar navigation
      dispatch(stopLoading());
    }).catch((error) => {
      console.error("Error loading profile:", error);
      setLoading(false);
      dispatch(stopLoading());
    });
  }, [auth, dispatch]);

  if (!auth) return null;

  return (
    <RootLayout>
      <PageLayout loading={loading} skeletonType="profile">
        {!loading && data && <ProfilePageContent data={data} />}
      </PageLayout>
    </RootLayout>
  );
};

export default ProfilePage;

